import {InputDate} from '@/components/commons/input-date/InputDate'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {useController, useFormContext, useWatch} from 'react-hook-form'
import {AddPatientAbsenceFormValidationSchema} from '../../formSchemas'
import {useTranslation} from '@/translations/i18n'
import {useMemo, useState} from 'react'
import dayjs from 'dayjs'
import {useGetEvents} from '../../queries/useGetEvents'
import {formatDate} from '@/dayjs'

export const AddPatientAbsenceDatesFields = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<AddPatientAbsenceFormValidationSchema>()
    const startDateController = useController({control, name: 'startDate'})
    const endDateController = useController({control, name: 'endDate'})
    const patientsWatch = useWatch({control, name: 'patients'})

    const [month, setMonth] = useState<Date>(startDateController.field.value ?? new Date())

    const {data: patientsEvents} = useGetEvents({
        params: {
            startDate: formatDate(dayjs(month).startOf('month').toDate()),
            endDate: formatDate(dayjs(month).endOf('month').toDate()),
            therapists: [],
            patients: patientsWatch?.length ? patientsWatch.map(p => p.id) : []
        },
        options: {
            enabled: !!patientsWatch?.length
        }
    })

    const patientAbsences = useMemo(() => {
        return (
            patientsEvents
                ?.filter(patientEvent => patientEvent.type == 'patient_absence')
                .map(patientEvent => dayjs(patientEvent.date).toDate()) || []
        )
    }, [patientsEvents])

    return (
        <Grid columns={2} gap={4} fullWidth>
            <InputDate
                value={startDateController.field.value}
                onChange={startDateController.field.onChange}
                fullWidth
                name="startDate"
                label={t('agenda:add_absence_start_date')}
                disableAfterDate={endDateController.field.value}
                errorMessage={startDateController.fieldState.error?.message}
                placeholder={'GG/MM/AAAA'}
                disabled={patientsWatch?.length < 1}
                onMonthChange={month => setMonth(month)}
                disabledDates={patientAbsences}
            />

            <InputDate
                value={endDateController.field.value}
                onChange={endDateController.field.onChange}
                fullWidth
                name="endDate"
                label={t('agenda:add_absence_end_date')}
                disableBeforeDate={startDateController.field.value}
                errorMessage={endDateController.fieldState.error?.message}
                placeholder={'GG/MM/AAAA'}
                disabled={patientsWatch?.length < 1}
                onMonthChange={month => setMonth(month)}
                disabledDates={patientAbsences}
            />
        </Grid>
    )
}
